<template>
  <div>
    <h4>TAREAS DE CONTACTO</h4>
    <div class="row">
      <div class="col">
        <button
          class="btn btn-success mb-3"
          @click="
            $refs.elModal.show();
            $refs.elForm.reset();
          "
        >
          <i class="fa fa-plus"></i> Nueva tarea de contacto
        </button>
      </div>
    </div>

    
    <app-apirest-table
      :getList="ServiceFactory.getContactTasks"
      :params="{ client_id: this.client_id }"
      ref="elApirestTable"
      v-slot:default="{ list }"
    >
      <thead>
        <tr>
          <th>FECHA</th>
          <th>REALIZADO</th>
          <th>ESTADO</th>
          <th>COMENTARIO</th>
          <th>TIPO</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(l, i) in list" :key="i">
          <td>{{ l.date_to_contact | date }}</td>
          <td>{{ l.maked ? "si" : "no" }}</td>
          <td>{{ statusDesc(l.status_id) }}</td>
          <td>{{ l.note }}</td>
          <td>
            <spanType :typeId="l.type_id"></spanType>
          </td>
        </tr>
      </tbody>
    </app-apirest-table>

    <app-modal-basic ref="elModal">
      <ContactTaskForm
        ref="elForm"
        :clientId="this.client_id"
        @saved="$refs.elModal.hide(); $refs.elApirestTable.reload()"
      ></ContactTaskForm>
    </app-modal-basic>
  </div>
</template>
<script>
import ContactTaskForm from "../contact-tasks/Form";
import ServiceFactory from "../../service-module/service";
import spanType from "../contact-tasks/spanType.vue";

export default {
  name: "PatientContactTasks",
  components: {
    ContactTaskForm,
    spanType
  },

  // directives
  // filters

  props: {
    client_id: {}
  },

  data: () => ({
    ServiceFactory,
  }),

  computed: {
    //
  },

  watch: {
    //
  },

  mounted() {
    //
  },

  methods: {
    statusDesc(status_id) {
      switch (status_id) {
        case 1:
          return "Pendiente";
        case 2:
          return "Citado";

        case 3:
          return "Reprogramado";

        case 4:
          return "Caso Cerrado";

        default:
          break;
      }
      return "";
    }
  }
};
</script>

<style></style>
